import Vue from "vue";
import { createHttpClient } from "@/helpers/httpFactory";
import { TOKEN_FLASHDEAL, TOKEN_POST_GRAB, TOKEN_REVISI } from "@/stores/constants";

Vue.prototype.$api = createHttpClient(); // Default instance

// Export various pre-configured instances
export const http = createHttpClient(); // v3 + bearer
export const http2 = createHttpClient({ headers: { "Content-Type": "application/json" } });
export const http3 = createHttpClient(); // v3
export const http4 = createHttpClient({
  basePath: "/v2/rgstrnsvc",
  useAuth: false,
  staticToken: TOKEN_REVISI,
});
export const http5 = createHttpClient({
  basePath: "/v2/rgstrnsvc",
  useAuth: false,
  staticToken: TOKEN_REVISI,
});
export const http6 = createHttpClient({ basePath: "/v2/rgstrnsvc", useAuth: false });
export const httpbffnew = createHttpClient({ basePath: "/v3/bffnew" });
export const httpAssignSurveyor = createHttpClient({ staticToken: TOKEN_POST_GRAB });
export const httpFromgrab = createHttpClient();
export const httpFromPromo = createHttpClient({ staticToken: TOKEN_FLASHDEAL });
export const httpFromReplika = createHttpClient({ staticToken: TOKEN_POST_GRAB });
export const httpSimulasi = createHttpClient({ basePath: "/v3/simulation/api" });
export const httpbranch = createHttpClient({ basePath: "/v3/branch-office" });
export const httpWithoutBearer = createHttpClient({ useAuth: false });
export const v1http = createHttpClient({ headers: { "Content-Type": "application/json" } });
export const httpComposer = createHttpClient({ basePath: "/v3/transaction-composer" });
